import type { PermissionsForRoles } from 'src/api/fm/permissions/permissions.model'
import { type AppState } from 'src/redux/app/app.store'

export const selectPermissionsForRoles = (state: AppState): PermissionsForRoles => state.permissionsForRoles.permissions
